export const RAPPI_ECOMMERCE_KEY = 'rappi';

const fullFieldsConfig = {
  fields: ['recipientDocument', 'recipientRelationship', 'signature'],
  requiredFields: ['recipientDocument', 'recipientRelationship', 'signature'],
};

export const ECOMMERCE_FIELDS_CONFIG = {
  naturacd: fullFieldsConfig,
  [RAPPI_ECOMMERCE_KEY]: fullFieldsConfig,
  default: {
    fields: ['recipientDocument', 'recipientRelationship'],
    requiredFields: ['recipientDocument', 'recipientRelationship'],
  },
};

export const getEcommerceFieldsConfig = (ecommerceName) => {
  const normalized = (ecommerceName?.toLowerCase().trim() ?? '').replace(
    /\s+/g,
    ''
  );

  const key = Object.keys(ECOMMERCE_FIELDS_CONFIG).find(
    (k) => k !== 'default' && normalized.includes(k)
  );

  return key ? ECOMMERCE_FIELDS_CONFIG[key] : ECOMMERCE_FIELDS_CONFIG.default;
};
